import React, { useState } from 'react';
import { Box, Typography, Divider} from '@mui/material';
import { Button,  Card} from '@mui/joy';
import Sheet from '@mui/joy/Sheet';
import { Grid } from '@mui/joy';
import StarIcon from '@mui/icons-material/Star';
import { Avatar } from '@mui/joy';
import { BreadcrumbTwo } from '../../component/common/Breadcrumb';


const Reviews = ({ rating, setRating }) => {
    const [hover, setHover] = useState(null);

    return (
        <Box sx={{ display: 'flex', gap: '5px' }}>
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                    <StarIcon
                        key={index}
                        style={{
                            cursor: 'pointer',
                            color: starValue <= (hover || rating) ? '#ffc107' : '#e4e5e9',
                        }}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(starValue)}
                    />
                );
            })}
        </Box>
    );
};

const initialData = [
    {
        id: '6541654651',
        name: 'Rolex hood',
        skill: 'Plubmbing, Cleaning, Appliance Repair, Installation, Uninstallation, Repair',
        location: '123, Street Name, Landmark,UK',
        price: 120,
        rating: 4,
        reviews: 'Customer Reviews',
        job: 'Post Job',
        servicecategories: 'Plumbing',
        subcategories: 'Pipe Instalation',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit',
        role: 'customer',
        date: '50/11/2025',
        time: '10:30pm',
        imagesUrl: 'assets/images/Mask group (11).png',
        star: 4,

    },
    {
        id: '6541654652',
        name: 'Rocky rock',
        skill: 'Plubmbing, Cleaning, Appliance Repair, Installation, Uninstallation, Repair',
        location: '123, Street Name, Landmark, City,India',
        price: 120,
        rating: 4,
        reviews: 'Customer Reviews',
        job: 'Post Job',
        servicecategories: 'Plumbing',
        subcategories: 'Pipe Instalation',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit',
        role: 'customer',
        date: '50/11/2025',
        time: '10:30pm',
        imagesUrl: 'assets/images/Mask group (11).png',
        star: 4,


    },
    {
        id: '6541654653',
        name: 'Ronny',
        skill: 'Plubmbing, Cleaning, Appliance Repair, Installation, Uninstallation, Repair',
        location: '123, Street Name, Landmark, City,US',
        price: 140,
        rating: 4,
        reviews: 'Customer Reviews',
        job: 'Post Job',
        servicecategories: 'Plumbing',
        subcategories: 'Pipe Instalation',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit',
        role: 'customer',
        date: '50/11/2025',
        time: '10:30pm',
        imagesUrl: 'assets/images/Mask group (11).png',
        star: 4,

    },

];

 const PastJob = () =>{

    const [data, setData] = useState(initialData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('price');

    const handleSortChange = (value) => {
        const [newOrder, newOrderBy] = value.split('-');
        setOrder(newOrder);
        setOrderBy(newOrderBy);
    };


    const sortedData = [...data].sort((a, b) => {
        if (orderBy === 'price') {
            return order === 'asc' ? a.price - b.price : b.price - a.price;
        } else if (orderBy === 'rating') {
            return order === 'asc' ? a.rating - b.rating : b.rating - a.rating;
        }
        return 0;
    });

    const updateRating = (id, newRating) => {
        setData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...item, rating: newRating } : item))
        );
    };

    return (
        <>
            <BreadcrumbTwo handleSortChange={handleSortChange} order={order} orderBy={orderBy} />

            <Box sx={{
                width: '1203px',
                margin: '2rem auto',

                
            }}>








                <Grid
                    container
                    item
                    spacing={{ xs: 0, md: 0 }}
                    columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                    sx={{ flexGrow: 1, width: '100%' }}
                >

                    {!sortedData && sortedData.length() >= 0 ? '' : sortedData.map((profile) => (
                        <Grid key={profile.id} item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '2rem', marginBottom: '3rem' }}>
                            <Card
                                size='lg'
                                variant='solid'

                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'grid',
                                    p: 2,
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: 'repeat(auto-fill, minmax(300px, 1fr))',
                                        md: 'repeat(auto-fill, minmax(600px, 1fr))',
                                        lg: 'repeat(auto-fill, maxmax(1258px, 1fr))',
                                    },
                                    gap: 2,
                                    borderRadius: '20px',
                                    border: '1px solid #666666',
                                    backgroundColor: '#fff'
                                }}
                            >



                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 1.5,
                                    width: '100%',
                                    maxWidth: '1207px',
                                    margin: 'auto',
                                   
                                }}
                                >
                                    <Box>
                                        <Typography level='h2'
                                            sx={{

                                                fontSize: '22px',
                                                fontWeight: 600,
                                                lineHeight: '33px',
                                                textAlign: 'left',
                                                color:'#666666'


                                            }}>{profile.id}</Typography>
                                    </Box>
                                    <Button variant='outlined'
                                        sx={{

                                            backgroundColor: '#abbfe0',
                                            color: '#6195e8',
                                            padding: '10px 50px',
                                            border: '1px solid ##abbfe0',
                                            '&:hover': {
                                                backgroundColor: '#abbfe0',
                                                color: '#6195e8', boxShadow: 3
                                            },
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        {profile.job}
                                    </Button>
                                </Box>

                                <Divider
                                    inset='none'
                                    sx={{
                                        width: '80%%',
                                        height: '3px',
                                        borderWidth: 2,
                                        borderColor: '#000000',
                                        backgroundColor: '#000000',

                                        
                                    }}
                                />



                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: '#fff',
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>Service Categories</Typography>
                                    </div>

                                    <div>
                                        <Typography level='body-xs' sx={{ fontWeight: 'lg' }}>
                                            {profile.servicecategories}
                                        </Typography>

                                    </div>
                                </Sheet>



                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: '#fff',
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>subcategories</Typography>
                                    </div>

                                    <div>
                                        <Typography level='body-xs' sx={{ fontWeight: 'lg' }}>
                                            {profile.subcategories}
                                        </Typography>

                                    </div>
                                </Sheet>
                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: '#fff',
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>Description</Typography>
                                    </div>

                                    <div>
                                        <Typography level='body-xs' sx={{ fontWeight: 'lg' }}>
                                            {profile.description}
                                        </Typography>

                                    </div>
                                </Sheet>
                                <Sheet
                                    sx={{

                                        display: 'flex',
                                        backgroundColor: '#fff',
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>Date & Time</Typography>
                                    </div>

                                    <div>
                                        <Typography level='body-xs' sx={{ fontWeight: 'lg' }}>
                                            {profile.date} & {profile.time}
                                        </Typography>

                                    </div>
                                </Sheet>
                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: '#fff',
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>Location</Typography>
                                    </div>

                                    <div>
                                        <Typography level='body-xs' sx={{ fontWeight: 'lg' }}>
                                            {profile.location}
                                        </Typography>

                                    </div>
                                </Sheet>

                                <Divider
                                    inset='none'
                                    sx={{
                                        width: 'auto',
                                        height: '2px',
                                        borderWidth: 2,
                                        borderColor: '#000000',
                                        backgroundColor: '#000000'

                                    }}
                                />
                                <Typography variant='h4'
                                    sx={{
                                        maxWidth: '100%', color: '#000000',
                                        fontSize: '22px',
                                        fontWeight: 600,
                                        lineHeight: '33px',
                                        textAlign: 'left',

                                    }}

                                >Fundi Details</Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between',
                                        mb: 2,
                                        p: 2,
                                        width: '100%',
                                       
                                    }}
                                >

                                    <Box sx={{ maxWidth: 161 }}>
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: 146,
                                                height: 146,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            
                                            <Avatar
                                                src={profile ? profile.imagesUrl : ''}
                                                alt={'Profile'}
                                                sx={{
                                                    width: '132.77px',
                                                    height: '132.77px',
                                                    backgroundColor: profile.imagesUrl ? 'transparent' : '#ffe',
                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: 146,
                                                    height: 146,
                                                    borderRadius: '50%',
                                                    border: '2px solid #2E2E2E',
                                                    boxSizing: 'border-box',
                                                    pointerEvents: 'none',
                                                }}
                                            />
                                        </Box>
                                    </Box>


                                    <Box sx={{ flex: 1, p: 3 }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: '400px',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            <Box sx={{ width: '200px', textAlign: 'left' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                                                    {profile.name}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: '160px', textAlign: 'end' }}>
                                                <Reviews
                                                    rating={profile.rating}
                                                    setRating={(newRating) => updateRating(profile.id, newRating)}
                                                />
                                            </Box>
                                        </Box>
                                        <Typography
                                            sx={{
                                                width: '400px',
                                                maxWidth: '100%',
                                                color: '#666666'
                                            }}
                                        >
                                            {profile.skill}
                                        </Typography>
                                    </Box>


                                    <Card
                                        sx={{
                                            padding: '10px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'start',
                                            textAlign: 'center',
                                            boxShadow: 'none',
                                            height: '150px',
                                            backgroundColor:'transparent !important',
                                            border:'none',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 'bold',
                                                mb: 2,
                                            }}
                                        >
                                            £ {profile.price}
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: 1.5,
                                                width: '100%',
                                                '& > button': {
                                                    flex: 1,
                                                },
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: '#d8d8d8',
                                                    color: '#666666',
                                                    width: '196px',
                                                    height: '39px',
                                                    borderRadius: '6px',
                                                    fontSize: '18px',
                                                    fontWeight: 500,
                                                    lineHeight: '27px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                               Payment Done
                                            </Button>
                                        </Box>
                                    </Card>

                                </Box>


                                <Card variant="plain" sx={{p:3}}>
                                    
                                        
                                        <Typography>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi reprehenderit eaque maiores voluptate corporis quibusdam ipsum veniam maxime, provident placeat mollitia explicabo, sint laborum aperiam quas praesentium. Quo nisi asperiores optio aspernatur, repellendus nam quidem praesentium voluptatibus reprehenderit non architecto nostrum sint debitis explicabo doloremque aliquid doloribus vel enim eveniet!</Typography>
                                        <Reviews
                                            rating={profile.rating}
                                            setRating={(newRating) => updateRating(profile.id, newRating)}
                                        />
                                </Card>

                            


                            </Card>




                        </Grid>


                    ))

                    }
                </Grid>
            </Box >
        </>
    );
}

export default  PastJob;